import React, { useEffect, useState } from "react";

const UploadFile = ({
  selectedFile,
  setSelectedFile,
  image,
  className,
  label,
  setImageForPackages,
  mandatory,
  placeholder,
  width,
  accept,
  height,
}) => {
  const [remove, setRemove] = useState(false);
  const [datafile, setDataFiles] = useState();
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  const handleRemoveImage = () => {
    setRemove(true);
    if (setImageForPackages) setImageForPackages(null);
    setSelectedFile();
  };
  return (
    <div className={className || "col-12"}>
      <div className="fieldrow">
        <label className="f_label">
          {label} <span style={{ color: "red" }}>{mandatory}</span>{" "}
        </label>
        <div className="upload_box">
          <input type="file" onChange={handleFileChange} accept={accept && accept || "image/*"} />
          <i className="ri-upload-cloud-2-line"></i>
          <span className="upload-text">{placeholder || "Click or drag file to upload"}</span>
          <span className="upload-info">Max file size: 10MB</span>
          {width && height && (
            <span>{`Height: ${height}, Width: ${width}`}</span>
          )}
        </div>
      </div>{" "}
      <div className="fieldrow uploaded_item">
        <ul>
          {selectedFile && (
            <li>
              {/* Handle both File objects and string URLs */}
              <iframe 
                src={
                  (selectedFile instanceof File || selectedFile instanceof Blob
                    ? URL.createObjectURL(selectedFile)
                    : selectedFile) + "#view=FitH&toolbar=0"
                } 
                style={{ width: "100%" }} 
              />

              <button onClick={handleRemoveImage} type="button">
                <i className="ri-close-line"></i>
              </button>
            </li>
          )}
          {image && !selectedFile && !remove && (
            <li>
              <iframe 
                src={image + "#view=FitH&toolbar=0"} 
                style={{ width: "100%" }} 
              />

              <button onClick={handleRemoveImage} type="button">
                <i className="ri-close-line"></i>
              </button>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default UploadFile;
